<template>
  <div class="animated fadeIn">
    <b-card-text class="text-left">
      <p>
        All set!  ChatAcuity will start analyzing your workspace shortly.  Depending on the level of activity in the channels you've just selected, the dashboard can take some hours to begin rendering.
      </p>

      <p>
        An email has been sent to the provided address containing your temporary password and your dashboard login URL.  You will be asked to change your password the first time you sign-in. 
      </p>

      <p>
        You can safely close this window.
      </p>

    </b-card-text>

  </div>
</template>


<script>
export default {
  name: 'Step4',
  props: {

  },

  methods: {
    nextButtonClick() {

    }
  },

  mounted() {
    this.$store.commit('installProgress', 100)
  }
}
</script>